// FileAttachment.jsx
import React from 'react';

// Download Icon SVG
const DownloadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true" className="stroke-2 h-5 w-5 text-indigo-600 dark:text-indigo-300 group-hover:text-indigo-700 dark:group-hover:text-indigo-200">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></path>
    </svg>
);

const FileAttachment = ({ file }) => {
    if (!file || !file.name || !file.url) {
        return null; // Don't render if data is missing
    }

    return (
        <div className="flex items-center my-2 p-3 rounded-lg bg-gray-100 dark:bg-gray-700/50 max-w-xs md:max-w-sm"> {/* Added background & padding */}
            {/* Download Button wrapped in Link */}
            <a
                href={file.url}
                download={file.name} // Suggests filename to browser
                target="_blank" // Open in new tab or prompt download
                rel="noopener noreferrer"
                title={`Download ${file.name}`}
                className="mr-3 flex-shrink-0" // Use link for click area
                // Prevent context menu on the link itself if needed
                onContextMenu={(e) => e.stopPropagation()}
            >
                 {/* Visually style as a button */}
                <div className="w-10 h-10 flex justify-center items-center rounded-full outline-none transition-all duration-200 bg-indigo-100 hover:bg-indigo-200 active:bg-indigo-300 dark:bg-indigo-900/50 dark:hover:bg-indigo-900/80 dark:active:bg-indigo-900 group">
                    <DownloadIcon />
                </div>
            </a>
            {/* File Info */}
            <div className="flex flex-col justify-center overflow-hidden"> {/* Added overflow-hidden */}
                <p className="outline-none text-sm font-medium leading-tight tracking-tight text-gray-700 dark:text-gray-200 truncate" title={file.name}>
                    {file.name}
                </p>
                {file.size && ( // Only show size if available
                    <p className="outline-none text-xs font-normal leading-tight tracking-tight text-gray-500 dark:text-gray-400 mt-0.5">
                        {file.size}
                    </p>
                )}
            </div>
        </div>
    );
};

export { FileAttachment };